import React from 'react';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { Collapse } from '@mui/material';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';

function BankAccountLayout({ classes }) {
  const { resource } = useMetaLayoutContext();
  return (
    <div className={classes.root}>
      <div className={classes.row}>
        <MetaField attr="ownerClientId" className={classes.alignLeft} />
        <MetaField attr="allocationType" className={classes.alignLeft} />
      </div>
      <div className={classes.row}>
        <MetaField attr="city" />
        <MetaField attr="state" />
      </div>
      <MetaField attr="country" />
      <div className={classes.row}>
        <MetaField attr="phone" />
        <MetaField attr="abaRouting" />
      </div>
      <MetaField attr="maturityDate" />
      <div className={classes.row}>
        <div>
          <MetaField attr="hasBeneficiary" />
        </div>
      </div>
      <Collapse in={resource.attr('hasBeneficiary') === 'true'}>
        <Box>
          <MetaField
            attr="primaryBeneficiary"
            hidden={resource.attr('hasBeneficiary') === 'false'}
          />
          <MetaField
            attr="contingentBeneficiary"
            hidden={resource.attr('hasBeneficiary') === 'false'}
          />
          <MetaField attr="isDomestic" />
        </Box>
      </Collapse>
    </div>
  );
}

BankAccountLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles({
  root: {},
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
  },
  alignLeft: {
    textAlign: 'left',
  },
})(BankAccountLayout);
